export const getCdnUrl = (path: string): string => {
  const cdnHost = process.env.NEXT_PUBLIC_CDN_HOST;
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
  const version = process.env.NEXT_PUBLIC_VERSION || 'latest';

  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  return `${cdnHost}/${environment}/${version}/${cleanPath}`;
};

// Helper function to determine if we should use CDN
export const shouldUseCdn = (): boolean => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
  // return ['beta', 'production'].includes(environment ?? '');
  return true;
};

// Helper function specifically for public folder assets
export const getPublicAssetUrl = (path: string): string => {
  // If URL already has a protocol/host, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Handle both with and without leading slash
  const assetPath = path.startsWith('/') ? path.slice(1) : path;
  return shouldUseCdn() ? getCdnUrl(assetPath) : `/${assetPath}`;
};
